export default class VehicleTaxation {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.inputs = this.DOM.el.querySelectorAll('[data-vehicle-taxation-input]');
        this.DOM.button = this.DOM.el.querySelector('[data-vehicle-taxation-button]');

        this.initEvents();
    }

    initEvents() {
        /* Add event listeners */
        if (this.DOM.inputs) {
            const queryParams = {};
            this.DOM.inputs.forEach((element) => {
                element.addEventListener("change", (e) => {
                    queryParams[element.getAttribute('data-vehicle-taxation-input-name')] = e.target.value;
                    this.DOM.button?.setAttribute('data-flow-query-params', JSON.stringify(queryParams));
                });
            });
        }
    }
}

const vehicleTaxationNodes = Array.from(document.querySelectorAll('[data-vehicle-taxation]'));
if (vehicleTaxationNodes !== null) {
    vehicleTaxationNodes.forEach((node) => { new VehicleTaxation(node); });
}
